module.exports = __webpack_public_path__ + "img/clinique-score.18d3801a.jpg";